import React, { Component, createRef } from 'react';
import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';
import JsBarcode from 'jsbarcode';
import { OxxoReferenceModel } from '../NewOrder';
import moment from 'moment';

class VoucherPDFComponent extends Component {
    constructor(props) {
        super(props);

        // const ref = new OxxoReferenceModel();
        // ref.IdOxxoRef = 12345;
        // ref.CreateDate = '2025-07-05';
        // ref.CreateTime = '11:30';
        // ref.ObjType = 'Factura';
        // ref.ObjSubType = 'Venta';
        // ref.CreateUser = 'Admin';
        // ref.DocEntry = '456';
        // ref.NumAtCard = 'FAC-2025-003';
        // ref.Reference = '123456789012'; // longitud válida para CODE 128
        // ref.RefNumericPartner = 'OX-9988';
        // ref.DueDate = '2025-07-10';
        // ref.RefTotal = '1,850.00';

        // this.state = {
        //     reference: ref
        // };

        // Ref del canvas para el código de barras
        this.barcodeRef = createRef();
    }

    componentDidMount() {
        // this.generateBarcode();
    }

    generateBarcode = () => {
        const { reference } = this.props;
        JsBarcode(this.barcodeRef.current, reference.Reference, {
            format: 'CODE128',
            width: 2,
            height: 40, // 1 cm = 28.35 puntos -> 40 puntos aprox = 1.4 cm
            displayValue: false,
            margin: 0,
        });
    };

    generatePDF = () => {
        const doc = new jsPDF();
        const { reference } = this.props;

        const barcodeImg = this.barcodeRef.current.toDataURL('image/png');
        const logo = new Image();
        logo.src = require('../../images/oxxoLogo.png');

        logo.onload = () => {
            // Encabezado con fondo rojo
            doc.setFillColor('#DF0024');
            doc.rect(0, 0, 210, 25, 'F'); // fondo rojo en la parte superior

            // Logo
            doc.addImage(logo, 'PNG', 15, 5, 30, 15);

            // Título en blanco dentro del header
            doc.setTextColor('#FFFFFF');
            doc.setFontSize(16);
            doc.text('VOUCHER DE REFERENCIA OXXO', 55, 15);

            // Restablecer color para cuerpo
            doc.setTextColor(0, 0, 0);

            // Info general en tabla
            autoTable(doc, {
                startY: 35,
                theme: 'grid',
                styles: {
                    fontSize: 11,
                    cellPadding: 4,
                    valign: 'middle'
                },
                headStyles: {
                    fillColor: [246, 211, 0], // amarillo OXXO
                    textColor: 0,
                    fontStyle: 'bold',
                },
                head: [['Campo', 'Valor']],
                body: [
                    ['Folio Interno', reference.IdOxxoRef],
                    ['Fecha', reference.CreateDate],
                    ['Hora', reference.CreateTime],
                    ['Usuario', reference.CreateUser],
                    ['Documento SAP', reference.DocEntry],
                    ['Número Cliente', reference.NumAtCard],
                    ['Tipo', reference.ObjType],
                    ['Subtipo', reference.ObjSubType],
                    ['Partner', reference.RefNumericPartner],
                    ['Total', `$${reference.RefTotal} MXN`],
                    ['Vencimiento', reference.DueDate],
                ],
            });

            // Espacio para código de barras
            const yPos = doc.lastAutoTable.finalY + 20;

            doc.setFontSize(13);
            doc.setTextColor('#DF0024'); // Rojo OXXO
            doc.text('Referencia de Pago:', 20, yPos);

            // Código
            doc.addImage(barcodeImg, 'PNG', 20, yPos + 5, 50, 10);
            doc.setFontSize(12);
            doc.setTextColor(0);
            doc.text(reference.Reference, 20, yPos + 20);

            // Footer decorativo amarillo
            doc.setFillColor('#F6D300');
            doc.rect(0, 280, 210, 10, 'F');

            doc.save(`OXXO_Ref_${reference.IdOxxoRef}.pdf`);
        };
    };

    generateFormattedVoucherPDF = async () => {
        await this.generateBarcode();
        const doc = new jsPDF();
        const margin = 10;
        const pageWidth = doc.internal.pageSize.getWidth();
        const usableWidth = pageWidth - margin * 2;

        const { reference } = this.props;
        const barcodeImg = this.barcodeRef.current.toDataURL('image/png');
        const formattedRef = reference.Reference.replace(/(.{4})/g, '$1 ').trim();

        const logo = new Image();
        logo.src = require('../../images/oxxoLogo.png');

        logo.onload = () => {
            let cursorY = margin;

            // Encabezado con borde y fondo naranja
            doc.setDrawColor('#DDDDDD');
            doc.setFillColor('#FFA500');
            doc.roundedRect(margin, cursorY, usableWidth, 15, 3, 3, 'FD');
            doc.setTextColor('#FFFFFF');
            doc.setFontSize(12);
            doc.text(`Paga antes del ${moment(reference.DueDate).format('DD-MM-YYYY')} a las ${reference.CreateTime}`, pageWidth / 2, cursorY + 11, { align: 'center' });

            cursorY += 25;


            // 📦 Primera sección: logo + código de barras + total
            const columnWidth = usableWidth / 2;
            doc.setDrawColor('#DDDDDD');
            doc.roundedRect(margin, cursorY, usableWidth, 35, 2, 2); // Borde general de esta sección

            // Logo izquierda
            doc.addImage(logo, 'PNG', margin + 10, cursorY + 10, 30, 15);

            // Derecha: código de barras
            doc.addImage(barcodeImg, 'PNG', margin + columnWidth + 5, cursorY + 3, 60, 12);
            doc.setFontSize(10);
            doc.setTextColor(0);
            doc.text(`${formattedRef}`, margin + columnWidth + 5, cursorY + 18);


            // Total a pagar
            doc.setFontSize(13);
            doc.setFont(undefined, 'bold');
            doc.text(`Total a pagar: $${reference.RefTotal / 100} MXN`, margin + columnWidth + 5, cursorY + 30);

            cursorY += 45;

            // 📋 Segunda sección
            doc.setDrawColor('#DDDDDD');
            doc.roundedRect(margin, cursorY, usableWidth, 80, 2, 2); // contenedor general

            const datosCompra = [
                ['Folio interno', reference.IdOxxoRef],
                ['Fecha', reference.CreateDate],
                ['Hora', reference.CreateTime],
                [`Usuario`, reference.CreateUser],
                ['Numero Doc.', reference.DocEntry],
                ['Folio Doc.', reference.NumAtCard],
                ['Tipo Doc', reference.ObjType],
                ['Subtipo Doc.', reference.ObjSubType],
            ];

            // Encabezado izquierdo
            doc.setFillColor('#F3F3F3');
            doc.setTextColor('#000000');
            doc.roundedRect(margin + 2, cursorY + 2, columnWidth - 4, 8, 2, 2, 'F');
            doc.setFontSize(11);
            doc.text('Datos de la compra', margin + 4, cursorY + 8);

            autoTable(doc, {
                startY: cursorY + 12,
                margin: { left: margin + 2 },
                tableWidth: columnWidth - 4,
                theme: 'plain',
                styles: { fontSize: 10, cellPadding: 1.5 },
                body: datosCompra.map(([campo, valor]) => [campo + ':', String(valor)]),
            });

            const compraEndY = doc.lastAutoTable.finalY;

            // Encabezado derecho
            doc.setFillColor('#F3F3F3');
            doc.roundedRect(margin + columnWidth + 3, cursorY + 2, columnWidth - 4, 8, 2, 2, 'F');
            doc.setTextColor('#000000');
            doc.text('Datos del pagador', margin + columnWidth + 5, cursorY + 8);

            const datosPagador = [
                ['ID Cliente', reference.RefNumericPartner],
                // ['Nombre', 'Juan Pérez'],
                // ['Email', 'juan.perez@email.com'],
                // ['Referencia', reference.Reference],
            ];

            autoTable(doc, {
                startY: cursorY + 12,
                margin: { left: margin + columnWidth + 3 },
                tableWidth: columnWidth - 4,
                theme: 'plain',
                styles: { fontSize: 10, cellPadding: 1.5 },
                body: datosPagador.map(([campo, valor]) => [campo + ':', valor]),
            });

            const finalY = Math.max(doc.lastAutoTable.finalY, compraEndY) + 10;
            const fullWidth = usableWidth;

            // 🧾 Sección inferior (contacto + legal)
            doc.setDrawColor('#DDDDDD');
            doc.roundedRect(margin, finalY, fullWidth, 24, 2, 2); // contenedor general

            // Fila 1: contacto
            doc.setFillColor('#f0f5f5');
            doc.roundedRect(margin + 1, finalY + 1, fullWidth - 2, 12, 2, 2, 'F');

            const icon = new Image();
            icon.src = require('../../images/ico/timbNomina.png'); // ícono de ayuda

            icon.onload = () => {
                doc.addImage(icon, 'PNG', margin + 4, finalY + 3, 8, 8);
                doc.setFontSize(9);
                doc.setTextColor('#000000');
                doc.setFont(undefined, 'bold');
                doc.text(
                    '¿Tienes dudas? Pregunta en cualquier sucursal o llama al 667 118 05 07',
                    margin + 15,
                    finalY + 9
                );

                // Fila 2: aviso legal
                doc.setFillColor('#616365');
                doc.roundedRect(margin + 1, finalY + 13, fullWidth - 2, 10, 2, 2, 'F');
                doc.setTextColor('#FFFFFF');
                doc.setFontSize(9);
                doc.setFont(undefined, 'bold');
                doc.text(
                    'La tienda OXXO en donde se efectúe el pago puede cobrar una comisión en concepto de cobranza.',
                    margin + 4,
                    finalY + 20
                );

                // ✔️ Mostrar vista previa
                const blobUrl = doc.output('bloburl');
                window.open(blobUrl, '_blank');
            };
        };
    };



    render() {
        return (
            <>
                <div className='col-md-2 align-items-center' style={{ cursor: 'pointer' }} onClick={this.generateFormattedVoucherPDF} >

                    <div className="row">
                        <div className="col-md-12 text-center mt-2" style={{ fontSize: '13px' }}>
                            OXXO VOUCHER
                        </div>
                    </div>
                </div>
                {/* Canvas oculto para generar el código de barras */}
                <canvas ref={this.barcodeRef} style={{ display: 'none' }} />
            </>
        );
    }
}

export default VoucherPDFComponent;
